import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=09c75b4f&scoped=true&"
var script = {}
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=09c75b4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c75b4f",
  null
  
)

export default component.exports